import { Routes } from '@angular/router';
import { HomePage } from './pages/home-page/home-page';
import { About } from './pages/about/about';
import { Faq } from './pages/faq/faq';
import { Shop } from './pages/shop/shop';
import { ShopStock } from './pages/shop-stock/shop-stock';
import { ShopCustom } from './pages/shop-custom/shop-custom';
import { Contact } from './pages/contact/contact';
import { Terms } from './pages/terms/terms';
import { Privacy } from './pages/privacy/privacy';
import { Returns } from './pages/returns/returns';

export const routes: Routes = [
  { path: '', component: HomePage },
  { path: 'about', component: About },
  { path: 'faq', component: Faq },
  { path: 'shop-stock', component: ShopStock },
  { path: 'shop-custom', component: ShopCustom },
  { path: 'shop', component: Shop },
  { path: 'contact', component: Contact },
  { path: 'terms', component: Terms },
  { path: 'privacy', component: Privacy },
  { path: 'returns', component: Returns },
  // The NgModule used { path: '*' }, which never matched anything - '*' is not
  // a wildcard in Angular, '**' is. Unknown paths therefore fell through to no
  // route at all. '**' makes the intended fallback actually work.
  { path: '**', component: HomePage },
];
